import { authorizeGetRequest } from "api";

export interface IDistanceResponse {
    distance: number;
    duration: number;
    distance_text: string;
    duration_text: string;
    origin_addresses: string;
    destination_addresses: string;
}

export const calculateDistanceApi = (
    pickupLat: number,
    pickupLng: number,
    dropoffLat: number,
    dropoffLng: number
) => {
    return authorizeGetRequest<IDistanceResponse>(
        `distance/calculate?pickup_lat=${pickupLat}&pickup_lng=${pickupLng}&dropoff_lat=${dropoffLat}&dropoff_lng=${dropoffLng}`
    );
};
